import LiquidText from '../components/LiquidText';
import { OrcamentoIcon, OrcamentoFeedbackProvider, useOrcamentoFeedback } from '../components/OrcamentoUI';
import React, { useState, useEffect } from 'react';
import api from '../services/api';

const LixeiraContent = () => {
    const { confirm, notify } = useOrcamentoFeedback();
    const [itens, setItens] = useState([]);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);
    const [filtro, setFiltro] = useState('todos'); // todos | obras | trabalhadores
    const [busy, setBusy] = useState(null); // chave do item em processamento

    const carregar = async () => {
        setLoading(true);
        setErro(null);
        try {
            const res = await api.get('/lixeira');
            setItens(res.data || []);
        } catch (err) {
            console.error('Erro ao carregar lixeira:', err);
            setErro('Não foi possível carregar a Lixeira.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { carregar(); }, []);

    const restaurar = async (item) => {
        const chave = `${item.entidade}-${item.id}`;
        setBusy(chave);
        try {
            await api.post('/lixeira/restaurar', { entidade: item.entidade, id: item.id });
            setItens(prev => prev.filter(i => !(i.entidade === item.entidade && i.id === item.id)));
        } catch (err) {
            console.error('Erro ao restaurar:', err);
            await notify('Erro ao restaurar o registo.');
        } finally {
            setBusy(null);
        }
    };

    const eliminarDefinitivo = async (item) => {
        if (!await confirm(
            `Eliminar DEFINITIVAMENTE "${item.nome}"?\n\nEsta ação é irreversível e remove o registo e todos os dados associados.`
        )) return;
        const chave = `${item.entidade}-${item.id}`;
        setBusy(chave);
        try {
            await api.delete(`/lixeira/${item.entidade}/${item.id}`);
            setItens(prev => prev.filter(i => !(i.entidade === item.entidade && i.id === item.id)));
        } catch (err) {
            console.error('Erro ao eliminar definitivamente:', err);
            await notify('Erro ao eliminar definitivamente.');
        } finally {
            setBusy(null);
        }
    };

    const fmtData = (d) => {
        if (!d) return '—';
        try { return new Date(d).toLocaleString('pt-PT'); } catch { return d; }
    };

    const itensFiltrados = itens.filter(i => filtro === 'todos' || i.entidade === filtro);

    return (
        <div className="admin-theme-page admin-trash-page" style={{ padding: '24px 28px' }}>
            <div className="admin-page-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: '1.5rem', display: 'flex', alignItems: 'center', gap: 8 }}>
                        <OrcamentoIcon name="trash" fallback="🗑️" /> Lixo
                    </h1>
                    <p style={{ margin: '4px 0 0', color: '#718096', fontSize: '0.9rem' }}>
                        Registos eliminados. Pode restaurá-los ou apagá-los definitivamente.
                    </p>
                </div>
                <button onClick={carregar} style={btnSec}><OrcamentoIcon name="refresh" fallback="↻" /> Atualizar</button>
            </div>

            <div className="admin-toolbar" style={{ display: 'flex', gap: 8, margin: '18px 0' }}>
                {[
                    { k: 'todos', label: 'Todos' },
                    { k: 'obras', label: 'Obras' },
                    { k: 'trabalhadores', label: 'Trabalhadores' },
                    { k: 'manutencao', label: 'Relatórios Manutenção' },
                ].map(t => (
                    <button
                        aria-pressed={filtro === t.k} key={t.k}
                        onClick={() => setFiltro(t.k)}
                        style={{ ...tabBtn, ...(filtro === t.k ? tabBtnActive : {}) }}
                    >
                        <LiquidText>{t.label}</LiquidText>
                    </button>
                ))}
            </div>

            {loading ? (
                <p style={{ color: '#718096' }}>A carregar…</p>
            ) : erro ? (
                <p style={{ color: '#e53e3e' }}>{erro}</p>
            ) : itensFiltrados.length === 0 ? (
                <div style={{ padding: '48px 0', textAlign: 'center', color: '#94a3b8' }}><LiquidText>
                    O Lixo está vazio. 🎉
                </LiquidText></div>
            ) : (
                <div className="admin-table-scroll" style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                        <thead>
                            <tr style={{ textAlign: 'left', color: '#64748b', borderBottom: '2px solid #e2e8f0' }}>
                                <th style={th}>Tipo</th>
                                <th style={th}>Nome</th>
                                <th style={th}>Eliminado em</th>
                                <th style={{ ...th, textAlign: 'right' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {itensFiltrados.map(item => {
                                const chave = `${item.entidade}-${item.id}`;
                                const processando = busy === chave;
                                return (
                                    <tr key={chave} style={{ borderBottom: '1px solid #edf2f7' }}>
                                        <td style={td}>
                                            <span className="admin-badge" style={badge}><LiquidText>{item.label}</LiquidText></span>
                                        </td>
                                        <td style={{ ...td, fontWeight: 500 }}>{item.nome || `#${item.id}`}</td>
                                        <td style={{ ...td, color: '#718096' }}>{fmtData(item.deleted_at)}</td>
                                        <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>
                                            <button
                                                onClick={() => restaurar(item)}
                                                disabled={processando}
                                                style={{ ...btnSec, marginRight: 8, opacity: processando ? 0.5 : 1 }}
                                            >
                                                <OrcamentoIcon name="back" fallback="↩" /> Restaurar
                                            </button>
                                            <button
                                                className="admin-danger" onClick={() => eliminarDefinitivo(item)}
                                                disabled={processando}
                                                style={{ ...btnDanger, opacity: processando ? 0.5 : 1 }}
                                            >
                                                <OrcamentoIcon name="trash" fallback="🗑" /> Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

const th = { padding: '10px 12px', fontWeight: 600, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.03em' };
const td = { padding: '12px' };
const badge = { background: '#edf2f7', color: '#475569', padding: '3px 10px', borderRadius: 12, fontSize: '0.78rem', fontWeight: 600 };
const tabBtn = { padding: '7px 16px', border: '1px solid #e2e8f0', background: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.85rem', color: '#475569' };
const tabBtnActive = { background: '#3182ce', color: '#fff', borderColor: '#3182ce' };
const btnSec = { padding: '7px 14px', border: '1px solid #cbd5e1', background: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem', color: '#334155' };
const btnDanger = { padding: '7px 14px', border: '1px solid #fed7d7', background: '#fff5f5', color: '#e53e3e', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem' };

export default function Lixeira() { return <OrcamentoFeedbackProvider><LixeiraContent /></OrcamentoFeedbackProvider>; }
